import { getChainId, } from "wagmi/actions";
import { wagmiConfig as config, } from "@wagmiconfig";
import { getExplorerLink, } from "@bracket/chainography";
import type { BlockHash,  } from "@bracket/types";
import type { Notification } from "@bracket/ui";
import type { ResolverResult, } from "@types";

export const dispatchNavNotification = (result: ResolverResult): Omit<Notification, "id"> | null => {
	
	if(result.success) {
		return navUpdateSuccessNotification(result.hash);
	}

	if(result.rejected) {
		return null;
	}

	return navUpdateFailedNotification(result.error);
}

/**
 * Creates a success notification for a successful claim transaction
 * 
 * @param {BrktTransaction} txn - The transaction details
 * @param {BlockHash} hash - The transaction hash
 * @returns {Omit<Notification, "id">} A notification object without an ID
 */
export const navUpdateSuccessNotification = (
	hash: BlockHash,
): Omit<Notification, "id"> => {
	return {
		title: "Nav update successful",
		message: "you successfully updated the NAV for this vault",
		type: "success",
		status: "success",
		primaryAction: {
			label: "View on explorer",
			onClick: () => {
				window.open(getExplorerLink(hash, getChainId(config)), "_blank");
			},
		},
	}
}

export const navUpdateRejectedNotification = (): Omit<Notification, "id"> => {
	return {
		title: "Nav update rejected",
		message: "the NAV update for this vault was rejected, please try again",
		type: "error",
		status: "error",
	}
}

export const navUpdateFailedNotification = (error: Error): Omit<Notification, "id"> => {
	const msg = error.message.toLowerCase();
	const message = (
		msg.includes("not a weistring") ? "invalid input, please check your values and try again" :
		msg.includes("vaultnotlocked") ? "vault is not locked, please lock the vault before updating the NAV" :
		"please try again"
	);

	console.warn("NAV updated failed", error.message);

	return {
		title: "Nav update failed",
		message: `the NAV update for this vault failed, ${message}`,
		type: "error",
		status: "error",
	}

}
